import React from "react";
import productionProcessImage from "../assets/Production process_new.webp"; // Ensure the correct image path

const ProductionProcess = () => {
    return (
        <div className="w-full bg-gray-900 text-white">
            {/* Production Process Section */}
            <div id="production-process" className="bg-gray-900 text-white p-12 sm:p-20 text-center">
  <h2 className="text-4xl sm:text-5xl font-bold mb-6">Production Process: Microalgae</h2>
  <p className="text-lg sm:text-xl leading-relaxed text-justify">
    Our industrial microalgae species production process is unique and ensures the highest quality standards.
    The process is optimized by our highly qualified and specialized R&D department, accompanied by the most modern and sophisticated industrial and laboratory technologies.
    <br /><br />
    The process integrates renewable energies, nutrient recycling, and efficient resource management 
    to create high-value products and sustainable energy.
  </p>

  {/* Large Production Process Image */}
  <div className="flex justify-center my-12">
    <img 
      src={productionProcessImage} 
      alt="Microalgae Production Process" 
      className="w-full max-w-4xl object-cover rounded-lg shadow-lg"
    />
  </div>
</div>

        </div>
    );
};

export default ProductionProcess;
